var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 100,
	"./layouts/card/style.module.scss": 100,
	"./layouts/components/breadcrumbs": 123,
	"./layouts/components/breadcrumbs/": 123,
	"./layouts/components/breadcrumbs/index": 123,
	"./layouts/components/breadcrumbs/index.tsx": 123,
	"./layouts/components/breadcrumbs/style.module": 182,
	"./layouts/components/breadcrumbs/style.module.scss": 182,
	"./layouts/components/container": 44,
	"./layouts/components/container/": 44,
	"./layouts/components/container/index": 44,
	"./layouts/components/container/index.tsx": 44,
	"./layouts/components/container/style.module": 125,
	"./layouts/components/container/style.module.scss": 125,
	"./layouts/components/footer": 124,
	"./layouts/components/footer/": 124,
	"./layouts/components/footer/index": 124,
	"./layouts/components/footer/index.tsx": 124,
	"./layouts/components/footer/style.module": 87,
	"./layouts/components/footer/style.module.scss": 87,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 98,
	"./layouts/components/nav_bar/": 98,
	"./layouts/components/nav_bar/index": 98,
	"./layouts/components/nav_bar/index.tsx": 98,
	"./layouts/components/nav_bar/standalone": 341,
	"./layouts/components/nav_bar/standalone.tsx": 341,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 86,
	"./layouts/components/notice_banner/": 86,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 183,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 183,
	"./layouts/components/notice_banner/index": 86,
	"./layouts/components/notice_banner/index.tsx": 86,
	"./layouts/components/notice_banner/standalone": 342,
	"./layouts/components/notice_banner/standalone.tsx": 342,
	"./layouts/components/notice_banner/style.module": 184,
	"./layouts/components/notice_banner/style.module.scss": 184,
	"./layouts/page": 99,
	"./layouts/page/": 99,
	"./layouts/page/index": 99,
	"./layouts/page/index.tsx": 99,
	"./layouts/page/style.module": 88,
	"./layouts/page/style.module.scss": 88,
	"./layouts/types": 343,
	"./layouts/types.ts": 343,
	"./marketing/pages/home/toefl": 1603,
	"./marketing/pages/home/toefl/": 1603,
	"./marketing/pages/home/toefl/index": 1603,
	"./marketing/pages/home/toefl/index.tsx": 1603,
	"./marketing/pages/home/toefl/sections/ai": 1198,
	"./marketing/pages/home/toefl/sections/ai/": 1198,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1863,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1863,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1864,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1864,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1865,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1865,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1866,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1866,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1867,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1867,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1868,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1868,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1869,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1869,
	"./marketing/pages/home/toefl/sections/ai/index": 1198,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1198,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1870,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1870,
	"./marketing/pages/home/toefl/sections/apps": 1199,
	"./marketing/pages/home/toefl/sections/apps/": 1199,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1871,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1871,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1872,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1872,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1873,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1873,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1874,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1874,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1875,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1875,
	"./marketing/pages/home/toefl/sections/apps/index": 1199,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1199,
	"./marketing/pages/home/toefl/sections/features": 1200,
	"./marketing/pages/home/toefl/sections/features/": 1200,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1876,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1876,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1877,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1877,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1878,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1878,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1879,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1879,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1880,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1880,
	"./marketing/pages/home/toefl/sections/features/index": 1200,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1200,
	"./marketing/pages/home/toefl/sections/official_questions": 1204,
	"./marketing/pages/home/toefl/sections/official_questions/": 1204,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1889,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1889,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1204,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1204,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 739,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 739,
	"./marketing/pages/home/toefl/sections/value_props": 1201,
	"./marketing/pages/home/toefl/sections/value_props/": 1201,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1881,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1881,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1882,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1882,
	"./marketing/pages/home/toefl/sections/value_props/index": 1201,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1201,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2266,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2266,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1202,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1202,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1883,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1883,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1884,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1884,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1885,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1885,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1886,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1886,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1887,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1887,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1202,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1202,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 738,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 738,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1203,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1203,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1888,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1888,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1203,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1203,
	"./marketing/pages/home/toefl/style.module": 1890,
	"./marketing/pages/home/toefl/style.module.scss": 1890,
	"./marketing/pages/plans/toefl": 1604,
	"./marketing/pages/plans/toefl/": 1604,
	"./marketing/pages/plans/toefl/index": 1604,
	"./marketing/pages/plans/toefl/index.tsx": 1604,
	"./marketing/pages/plans/toefl/sections/testimonials": 1205,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1205,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1891,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1891,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1892,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1892,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1205,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2606;